module.exports = __webpack_public_path__ + "img/点击进行人脸识别.f214f2a7.png";